import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom"; 
const API_BASE = "https://api.topgunapp.com";

export default function BlogPage() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/v1/aircrafts/blog/`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch blog posts");
        return res.json();
      })
      .then((data) => {
        setBlogPosts(data.results);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="container">Loading...</p>;
  if (error) return <p className="container">Error: {error}</p>;

  return (
    <section className="section container" style={{ paddingTop: "8rem" }}>
      <Helmet>
        <title>TopGun Aviation Blog</title>
        <meta
          name="description"
          content="Latest military aviation news, aircraft analysis, and TopGun Aviation Academy updates."
        />
      </Helmet>

      <h1 className="section__title section__title-gradient">Blog</h1>

      <div style={{ display: "grid", gap: "2rem", marginTop: "2rem" }}>
        {blogPosts.map((p) => (
          <article
            key={p.id}
            style={{
              background: "#666",
              borderRadius: "1rem",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,.6)",
            }}
          >
            {/* Blog image */}
            {p.image && (
              <img
                src={`${API_BASE}${p.image}`}
                alt={p.title}
                style={{
                  width: "100%",
                  height: "320px",
                  objectFit: "cover",
                }}
              />
            )}

            <div style={{ padding: "1.5rem" }}>
              {/* Source */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: ".5rem",
                  marginBottom: ".5rem",
                }}
              >
                {p.source_logo && (
                  <img
                    src={`${API_BASE}${p.source_logo}`}
                    alt={p.source}
                    style={{ width: 24, height: 24, borderRadius: "50%" }}
                  />
                )}
                <span
                  style={{
                    fontSize: ".85rem",
                    color: "var(--text-color-light)",
                  }}
                >
                  {p.source} •{" "}
                  {new Date(p.created).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
              </div>

              {/* Title */}
              <h2 style={{ marginBottom: ".5rem" }}>{p.title}</h2>

              {/* Sub header */}
              {p.sub_header && (
                <h4
                  style={{
                    marginBottom: "1rem",
                    color: "var(--text-color-light)",
                    fontWeight: 400,
                  }}
                >
                  {p.sub_header}
                </h4>
              )}

              {/* Full description */}
              <div
                style={{
                  lineHeight: "1.9rem",
                  whiteSpace: "pre-line",
                }}
                className="summery"
              >
                {p.description}
              </div>
              <div style={{ marginTop: ".75rem" }}> <Link to={`/blog/${p.id}`} className="button button--flex"> Read more <i className="ri-arrow-right-line" /> </Link> </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
